// Test product data with local 3D asset
export const productDataTest = [{
    id: 0,
    name: "Test Garment (Three.js)",
    price: "220",
    description: "Test Product: Three.js implementation with cloth physics. This is a test garment to verify the new 3D rendering system works correctly.",
    image: "/3_D_Trial_Product_ac19ec0ede.glb", // Local test asset in public directory
    poster: "https://cdn.glitch.com/f341fe61-4868-4d79-bad9-1a5804bea407%2Fposter.png?v=1627186159279",
    images: [
        "https://i.ibb.co/s6bhDzs/5c2cda56a97bc40295eb8328.png",
        "https://i.ibb.co/PYFZWnD/5c2cda69a97bc40295eb832a.png"
    ],
    custom1Name: "Size",
    custom1Options: "XS | S | M | L | XL | XXL",
    custom2Name: "Color",
    custom2Options: "Test Color",
    url: 'https://mapso.co/products.json',
    crypto: "https://commerce.coinbase.com/checkout/8be76dd9-aaf7-4044-97c9-ec9c4c21868d"
}]; 